import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import { boxShadow } from "core/SiteHeader/constants";
import { easingSeconds } from "core/animation";
import { A } from "core/Typography";
import fonts from "core/fonts";
import colors from "core/colors";

const LinkA = styled(A)`
    &,
    &:visited {
        color: ${({ isHeroSearchV2 }) =>
            isHeroSearchV2 ? colors.fossil : colors.snow};
        text-decoration: none;
        font-size: 0.875rem;
        transition: all ${easingSeconds};

        &:hover {
            color: ${({ isHeroSearchV2 }) =>
                isHeroSearchV2 ? colors.ink : fonts.fontColors.light.link};
            text-decoration: underline;
        }
    }
`;

let Link = ({ children, className, ...anchorProps }) => (
    <li className={className}>
        <LinkA {...anchorProps}>{children}</LinkA>
    </li>
);

Link = styled(Link)``;

Link.propTypes = {
    href: PropTypes.string,
    onClick: PropTypes.func
};

export { Link };

export const Wrapper = styled.nav`
    position: absolute;
    left: 0;
    z-index: 100;
    background-color: ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 ? colors.snow : colors.midnight};
    width: 13.125rem;
    padding: 1.6875rem 1.875rem 1.8125rem;

    ${({ isHeroSearchV2 }) => isHeroSearchV2 && `box-shadow: ${boxShadow}`};

    ${Link} {
        &:not(:last-of-type) {
            margin-bottom: 1.5rem;
        }
    }
`;
